import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.payGroupValidation = function () {
        const dictonary = {
            custom: {
                payGroup: {
                    required: () => t.t(dictEnum.LBL_PayGroup) + t.t(dictEnum.WARN_IsRequired)
                },
                payGroupDesc: {
                    required: () => t.t(dictEnum.LBL_PayGroupDesc) + t.t(dictEnum.WARN_IsRequired)
                },
                payType: {
                    required: () => t.t(dictEnum.LBL_PayType) + t.t(dictEnum.WARN_IsRequired)
                },
                payMethod: {
                    required: () => t.t(dictEnum.LBL_PayMethod) + t.t(dictEnum.WARN_IsRequired)
                },
                payStartDay: {
                    required: () => t.t(dictEnum.LBL_PayrollStartDay) + t.t(dictEnum.WARN_IsRequired)
                },
                payDefaultDay: {
                    required: () => t.t(dictEnum.LBL_PayrollDefaultDay) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082000-PayGroup/S082000-PayGroupValidation.js